import React, { useState, useEffect, useRef } from 'react';

// 12 citations patrimoniales/immobilier — rotation aléatoire
const QUOTES = [
  { text: "Achetez la terre, on n'en fait plus.", author: "Mark Twain" },
  { text: "Le meilleur moment pour acheter un bien immobilier était il y a vingt ans. Le deuxième meilleur moment, c'est aujourd'hui.", author: "Proverbe chinois" },
  { text: "L'immobilier ne peut être perdu, ni emporté.", author: "Franklin D. Roosevelt" },
  { text: "Quatre-vingt-dix pour cent des millionnaires le sont devenus grâce à l'immobilier.", author: "Andrew Carnegie" },
  { text: "Ne mettez pas tous vos œufs dans le même panier — sauf si ce panier est en pierre.", author: "Adage patrimonial" },
  { text: "L'investissement le plus important que vous puissiez faire est en vous-même.", author: "Warren Buffett" },
  { text: "La discipline est le pont entre les objectifs et leur accomplissement.", author: "Jim Rohn" },
  { text: "Le risque vient de ne pas savoir ce que l'on fait.", author: "Warren Buffett" },
  { text: "Un investisseur patient bat toujours un investisseur impatient.", author: "Charlie Munger" },
  { text: "Ne sauvez pas ce qu'il reste après avoir dépensé. Dépensez ce qu'il reste après avoir épargné.", author: "Warren Buffett" },
  { text: "La fortune favorise les esprits préparés.", author: "Louis Pasteur" },
  { text: "Le temps est l'ami de la belle entreprise et l'ennemi de la médiocre.", author: "Warren Buffett" },
];

const pickQuote = () => QUOTES[Math.floor(Math.random() * QUOTES.length)];

const DossierLoadingScreen = ({ title = "L'Équipage Odys", subtitle = null, fadeOut = false }) => {
  const [quote, setQuote] = useState(pickQuote());
  const [logoError, setLogoError] = useState(false);
  const startTime = useRef(Date.now());
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    // Rotation citation toutes les 4.5s
    const q = setInterval(() => setQuote(pickQuote()), 4500);

    // Progress bar progressive : 0→25% en 0.4s, 25→70% en 0.9s, 70→95% en 0.9s, reste à 95%
    const tick = () => {
      const elapsed = Date.now() - startTime.current;
      let p;
      if (elapsed < 400) p = (elapsed / 400) * 25;
      else if (elapsed < 1300) p = 25 + ((elapsed - 400) / 900) * 45;
      else if (elapsed < 2200) p = 70 + ((elapsed - 1300) / 900) * 25;
      else p = 95;
      setProgress(p);
    };
    const p = setInterval(tick, 50);
    return () => { clearInterval(q); clearInterval(p); };
  }, []);

  return (
    <div
      className={`dossier-splash ${fadeOut ? 'is-fading' : ''}`}
      data-testid="dossier-loading-screen"
      role="status"
      aria-live="polite"
    >
      {/* Ornement compass + logo central */}
      <div className="dossier-splash-emblem" aria-hidden="true">
        <svg className="dossier-splash-orbit" viewBox="0 0 200 200">
          <circle cx="100" cy="100" r="92" fill="none" stroke="#B5894A" strokeWidth="1.2" strokeDasharray="3 5" opacity="0.85" />
          <circle cx="100" cy="100" r="72" fill="none" stroke="#B5894A" strokeWidth="1" strokeDasharray="2 6" opacity="0.5" />
          <path
            d="M100 36 L108 92 L164 100 L108 108 L100 164 L92 108 L36 100 L92 92 Z"
            fill="#B5894A"
            opacity="0.55"
          />
        </svg>
        <div className="dossier-splash-ring" />
        <div className="dossier-splash-logo">
          {logoError ? (
            <span className="dossier-splash-logo-fallback">EO</span>
          ) : (
            <img
              src="/logo-192.png"
              alt="Odys"
              onError={() => setLogoError(true)}
            />
          )}
        </div>
      </div>

      {/* Brand title + filet */}
      <h1 className="dossier-splash-title">
        <span className="ink">{title.split(' ')[0]}</span>{' '}
        <span className="gold">{title.split(' ').slice(1).join(' ') || ''}</span>
      </h1>
      <div className="dossier-splash-filet" aria-hidden="true" />

      {/* Quote */}
      <div className="dossier-splash-quote" key={quote.text}>
        <p className="quote">« {quote.text} »</p>
        <p className="author">— {quote.author.toUpperCase()}</p>
      </div>

      {subtitle && <p className="dossier-splash-subtitle">{subtitle}</p>}

      {/* Progress bar progressive */}
      <div className="dossier-splash-progress" aria-label={`Chargement ${Math.round(progress)}%`}>
        <div className="bar" style={{ width: `${progress}%` }} />
      </div>
    </div>
  );
};

export default DossierLoadingScreen;
